import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { MemberCommunicationsPage } from '@/pages/member-portal/communications/MemberCommunicationsPage';

// Loose so the child answer route keeps its own search keys.
const viewerCommunicationsSearchSchema = z.looseObject({
	search: z.coerce.string().optional().catch(undefined),
});

function MemberPortalCommunicationsRoute() {
	return <MemberCommunicationsPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/communications')({
	component: MemberPortalCommunicationsRoute,
	validateSearch: viewerCommunicationsSearchSchema,
});
